"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var solana_headless_react_1 = require("@hermis/solana-headless-react");
var solana_headless_core_1 = require("@hermis/solana-headless-core");
require("./TransactionCard.css");
var TransactionCard = function (_a) {
    var onTransactionSent = _a.onTransactionSent;
    var dualConnection = (0, solana_headless_react_1.useConnection)().connection;
    var connection = dualConnection;
    var _b = (0, solana_headless_react_1.useWallet)(), publicKey = _b.publicKey, sendTransaction = _b.sendTransaction, signTransaction = _b.signTransaction, wallet = _b.wallet, signAndSendTransaction = _b.signAndSendTransaction;
    var _c = (0, react_1.useState)(''), recipient = _c[0], setRecipient = _c[1];
    var _d = (0, react_1.useState)(''), amount = _d[0], setAmount = _d[1];
    var _e = (0, react_1.useState)(false), isSending = _e[0], setIsSending = _e[1];
    var _f = (0, react_1.useState)(false), isSigningKit = _f[0], setIsSigningKit = _f[1];
    var _g = (0, react_1.useState)(false), isSendingKit = _g[0], setIsSendingKit = _g[1];
    var _h = (0, react_1.useState)(false), isSignAndSending = _h[0], setIsSignAndSending = _h[1];
    var _j = (0, react_1.useState)(false), isKitTransactionDemo = _j[0], setIsKitTransactionDemo = _j[1];
    var _k = (0, react_1.useState)(null), signature = _k[0], setSignature = _k[1];
    var _l = (0, react_1.useState)(null), error = _l[0], setError = _l[1];
    var _m = (0, react_1.useState)([]), architectureLog = _m[0], setArchitectureLog = _m[1];
    var status = (0, solana_headless_react_1.useSolanaTransaction)(signature || undefined).status;
    var isValidSolanaAddress = function (address) {
        try {
            new solana_headless_core_1.PublicKey(address);
            return true;
        }
        catch (_a) {
            return false;
        }
    };
    var addArchitectureLog = function (message) {
        var timestamp = new Date().toLocaleTimeString();
        var logEntry = "[".concat(timestamp, "] ").concat(message);
        setArchitectureLog(function (prev) { return __spreadArray(__spreadArray([], prev, true), [logEntry], false); });
        console.log("\uD83D\uDD0D ".concat(logEntry));
    };
    var clearLogs = function () {
        setArchitectureLog([]);
    };
    var handleSendTransaction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var parsedAmount, transaction, blockhash, txSignature, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!publicKey || !connection || !signTransaction || !sendTransaction || !signAndSendTransaction)
                        return [2 /*return*/];
                    // Validate inputs
                    if (!recipient || !amount) {
                        setError('Please enter both recipient address and amount');
                        return [2 /*return*/];
                    }
                    if (!isValidSolanaAddress(recipient)) {
                        setError('Invalid Solana address');
                        return [2 /*return*/];
                    }
                    parsedAmount = parseFloat(amount);
                    if (isNaN(parsedAmount) || parsedAmount <= 0) {
                        setError('Please enter a valid amount');
                        return [2 /*return*/];
                    }
                    setIsSending(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    transaction = new solana_headless_core_1.Transaction();
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 2:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    transaction.add(solana_headless_core_1.SystemProgram.transfer({
                        fromPubkey: publicKey,
                        toPubkey: new solana_headless_core_1.PublicKey(recipient),
                        lamports: parsedAmount * solana_headless_core_1.LAMPORTS_PER_SOL
                    }));
                    return [4 /*yield*/, signAndSendTransaction(transaction, connection)];
                case 3:
                    txSignature = _a.sent();
                    setSignature(txSignature);
                    if (onTransactionSent) {
                        onTransactionSent(txSignature);
                    }
                    setAmount('');
                    setRecipient('');
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _a.sent();
                    console.error('Error sending transaction:', err_1);
                    setError(err_1.message || 'Failed to send transaction');
                    return [3 /*break*/, 6];
                case 5:
                    setIsSending(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Sign transaction using Kit (dual architecture)
    var handleSignTransactionKit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var parsedAmount, transaction, blockhash, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!publicKey || !connection || !(wallet === null || wallet === void 0 ? void 0 : wallet.adapter))
                        return [2 /*return*/];
                    setError(null);
                    setIsSigningKit(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    // Validate inputs
                    if (!recipient || !amount) {
                        setError('Please enter both recipient address and amount');
                        return [2 /*return*/];
                    }
                    if (!isValidSolanaAddress(recipient)) {
                        setError('Invalid Solana address');
                        return [2 /*return*/];
                    }
                    parsedAmount = parseFloat(amount);
                    if (isNaN(parsedAmount) || parsedAmount <= 0) {
                        setError('Please enter a valid amount');
                        return [2 /*return*/];
                    }
                    transaction = new solana_headless_core_1.Transaction();
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 2:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    transaction.add(solana_headless_core_1.SystemProgram.transfer({
                        fromPubkey: publicKey,
                        toPubkey: new solana_headless_core_1.PublicKey(recipient),
                        lamports: parsedAmount * solana_headless_core_1.LAMPORTS_PER_SOL
                    }));
                    // Use dual architecture signTransaction - this will detect wallet type and route appropriately
                    return [4 /*yield*/, (0, solana_headless_react_1.signTransaction)(transaction, wallet.adapter)];
                case 3:
                    // Use dual architecture signTransaction - this will detect wallet type and route appropriately
                    _a.sent();
                    alert('Transaction signed successfully using Kit!');
                    return [3 /*break*/, 6];
                case 4:
                    err_2 = _a.sent();
                    console.error('Error signing transaction with Kit:', err_2);
                    setError(err_2.message || 'Failed to sign transaction with Kit');
                    return [3 /*break*/, 6];
                case 5:
                    setIsSigningKit(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Send transaction using Kit (dual architecture)
    var handleSendTransactionKit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var parsedAmount, transaction, blockhash, txSignature, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!publicKey || !connection || !(wallet === null || wallet === void 0 ? void 0 : wallet.adapter))
                        return [2 /*return*/];
                    setError(null);
                    setIsSendingKit(true);
                    addArchitectureLog(' Starting Kit-style sendTransaction demo...');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    // Validate inputs
                    if (!recipient || !amount) {
                        setError('Please enter both recipient address and amount');
                        return [2 /*return*/];
                    }
                    if (!isValidSolanaAddress(recipient)) {
                        setError('Invalid Solana address');
                        return [2 /*return*/];
                    }
                    parsedAmount = parseFloat(amount);
                    if (isNaN(parsedAmount) || parsedAmount <= 0) {
                        setError('Please enter a valid amount');
                        return [2 /*return*/];
                    }
                    // Create the transaction
                    addArchitectureLog('Creating Transaction object (web3.js style)');
                    transaction = new solana_headless_core_1.Transaction();
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 2:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    transaction.add(solana_headless_core_1.SystemProgram.transfer({
                        fromPubkey: publicKey,
                        toPubkey: new solana_headless_core_1.PublicKey(recipient),
                        lamports: parsedAmount * solana_headless_core_1.LAMPORTS_PER_SOL
                    }));
                    addArchitectureLog('Calling sendTransaction with Transaction + WalletAdapter');
                    addArchitectureLog('Expected path: Legacy detection → adapter.sendTransaction()');
                    return [4 /*yield*/, (0, solana_headless_react_1.sendTransaction)(connection, transaction, wallet.adapter)];
                case 3:
                    txSignature = _a.sent();
                    setSignature(txSignature);
                    if (onTransactionSent) {
                        onTransactionSent(txSignature);
                    }
                    setAmount('');
                    setRecipient('');
                    addArchitectureLog("\u2705 Transaction sent successfully: ".concat(txSignature.substring(0, 16), "..."));
                    return [3 /*break*/, 6];
                case 4:
                    err_3 = _a.sent();
                    console.error('Error sending transaction with Kit:', err_3);
                    setError(err_3.message || 'Failed to send transaction with Kit');
                    addArchitectureLog("\u274C Error: ".concat(err_3.message));
                    return [3 /*break*/, 6];
                case 5:
                    setIsSendingKit(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Sign and Send Transaction (combined operation)
    var handleSignAndSendTransaction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var parsedAmount, transaction, blockhash, txSignature, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!publicKey || !connection || !(wallet === null || wallet === void 0 ? void 0 : wallet.adapter))
                        return [2 /*return*/];
                    setError(null);
                    setIsSignAndSending(true);
                    addArchitectureLog(' Starting signAndSendTransaction demo...');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    // Validate inputs
                    if (!recipient || !amount) {
                        setError('Please enter both recipient address and amount');
                        return [2 /*return*/];
                    }
                    if (!isValidSolanaAddress(recipient)) {
                        setError('Invalid Solana address');
                        return [2 /*return*/];
                    }
                    parsedAmount = parseFloat(amount);
                    if (isNaN(parsedAmount) || parsedAmount <= 0) {
                        setError('Please enter a valid amount');
                        return [2 /*return*/];
                    }
                    // Create the transaction
                    addArchitectureLog('Creating Transaction for combined sign & send operation');
                    transaction = new solana_headless_core_1.Transaction();
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 2:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    transaction.add(solana_headless_core_1.SystemProgram.transfer({
                        fromPubkey: publicKey,
                        toPubkey: new solana_headless_core_1.PublicKey(recipient),
                        lamports: parsedAmount * solana_headless_core_1.LAMPORTS_PER_SOL
                    }));
                    addArchitectureLog('Calling signAndSendTransaction (NEW METHOD!)');
                    addArchitectureLog('This combines signing + sending in one dual architecture call');
                    return [4 /*yield*/, (0, solana_headless_react_1.signAndSendTransaction)(connection, transaction, wallet.adapter)];
                case 3:
                    txSignature = _a.sent();
                    setSignature(txSignature);
                    if (onTransactionSent) {
                        onTransactionSent(txSignature);
                    }
                    setAmount('');
                    setRecipient('');
                    addArchitectureLog("\u2705 Combined operation successful: ".concat(txSignature.substring(0, 16), "..."));
                    return [3 /*break*/, 6];
                case 4:
                    err_4 = _a.sent();
                    console.error('Error with sign and send transaction:', err_4);
                    setError(err_4.message || 'Failed to sign and send transaction');
                    addArchitectureLog("\u274C Error: ".concat(err_4.message));
                    return [3 /*break*/, 6];
                case 5:
                    setIsSignAndSending(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Kit Transaction Demo (pure kit architecture)
    var handleKitTransactionDemo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var kitKeypair, kitTransaction, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(null);
                    setIsKitTransactionDemo(true);
                    addArchitectureLog('🟢 Starting pure Kit architecture demo...');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    addArchitectureLog('Generating Kit CryptoKeyPair...');
                    return [4 /*yield*/, (0, solana_headless_react_1.generateKitKeypair)()];
                case 2:
                    kitKeypair = _a.sent();
                    addArchitectureLog('Creating Kit TransactionMessage...');
                    return [4 /*yield*/, (0, solana_headless_react_1.createKitTransaction)(connection, kitKeypair.address, [] // Empty instructions for demo
                        )];
                case 3:
                    kitTransaction = _a.sent();
                    addArchitectureLog('Checking architecture support...');
                    addArchitectureLog("Kit wallet support: ".concat((0, solana_headless_react_1.supportsKitArchitecture)(kitKeypair.keypair)));
                    addArchitectureLog("Kit transaction type: ".concat((0, solana_headless_react_1.isKitTransaction)(kitTransaction)));
                    addArchitectureLog('Signing with signTransaction...');
                    addArchitectureLog('Expected path: Kit detection → kit signing methods');
                    return [4 /*yield*/, (0, solana_headless_react_1.signTransaction)(kitTransaction, kitKeypair.keypair)];
                case 4:
                    _a.sent();
                    addArchitectureLog("\u2705 Kit transaction signed successfully!");
                    addArchitectureLog('This used TransactionMessage + CryptoKeyPair → Kit signing path');
                    return [3 /*break*/, 7];
                case 5:
                    err_5 = _a.sent();
                    console.error('Error with Kit transaction demo:', err_5);
                    setError(err_5.message || 'Failed to demonstrate Kit transaction');
                    addArchitectureLog("\u274C Kit demo error: ".concat(err_5.message));
                    return [3 /*break*/, 7];
                case 6:
                    setIsKitTransactionDemo(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    if (!publicKey) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "transaction-card", children: [(0, jsx_runtime_1.jsx)("div", { className: "transaction-card-header", children: (0, jsx_runtime_1.jsx)("h3", { children: "Send SOL" }) }), (0, jsx_runtime_1.jsx)("div", { className: "transaction-card-body", children: (0, jsx_runtime_1.jsx)("p", { className: "transaction-card-message", children: "Please connect a wallet to send transactions" }) })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "transaction-card", children: [(0, jsx_runtime_1.jsx)("div", { className: "transaction-card-header", children: (0, jsx_runtime_1.jsx)("h3", { children: "Send SOL" }) }), (0, jsx_runtime_1.jsx)("div", { className: "transaction-card-body", children: (0, jsx_runtime_1.jsxs)("div", { className: "transaction-form", children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "recipient", children: "Recipient Address" }), (0, jsx_runtime_1.jsx)("input", { id: "recipient", type: "text", placeholder: "Enter Solana address", value: recipient, onChange: function (e) { return setRecipient(e.target.value); }, disabled: isSending })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "amount", children: "Amount (SOL)" }), (0, jsx_runtime_1.jsx)("input", { id: "amount", type: "number", step: "0.001", min: "0", placeholder: "0.0", value: amount, onChange: function (e) { return setAmount(e.target.value); }, disabled: isSending })] }), error && (0, jsx_runtime_1.jsx)("div", { className: "transaction-error", children: error }), signature && ((0, jsx_runtime_1.jsxs)("div", { className: "transaction-result", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Transaction: ", (0, jsx_runtime_1.jsx)("span", { className: "tx-signature", children: signature })] }), (0, jsx_runtime_1.jsxs)("p", { children: ["Status: ", (0, jsx_runtime_1.jsx)("span", { className: "tx-status tx-status-".concat((status === null || status === void 0 ? void 0 : status.status) || 'pending'), children: (status === null || status === void 0 ? void 0 : status.status) || 'Processing...' })] })] })), architectureLog.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "architecture-log", children: [(0, jsx_runtime_1.jsxs)("div", { className: "log-header", children: [(0, jsx_runtime_1.jsx)("h5", { children: "\uD83D\uDD0D Architecture Detection Log" }), (0, jsx_runtime_1.jsx)("button", { onClick: clearLogs, className: "clear-log-button", children: "Clear" })] }), (0, jsx_runtime_1.jsx)("div", { className: "log-content", children: architectureLog.map(function (log, index) { return ((0, jsx_runtime_1.jsx)("div", { className: "log-entry", children: log }, index)); }) })] })), (0, jsx_runtime_1.jsxs)("div", { className: "button-group", children: [(0, jsx_runtime_1.jsxs)("div", { className: "button-section", children: [(0, jsx_runtime_1.jsx)("h5", { children: " Web3.js Style (Legacy)" }), (0, jsx_runtime_1.jsx)("button", { className: "send-button", onClick: handleSendTransaction, disabled: isSending || isSigningKit || isSendingKit || isSignAndSending || isKitTransactionDemo, children: isSending ? 'Sending...' : 'Send SOL (Standard)' }), (0, jsx_runtime_1.jsx)("button", { className: "send-button kit-button", onClick: handleSignTransactionKit, disabled: isSending || isSigningKit || isSendingKit || isSignAndSending || isKitTransactionDemo, children: isSigningKit ? 'Signing...' : 'Sign Transaction (Dual)' }), (0, jsx_runtime_1.jsx)("button", { className: "send-button kit-button", onClick: handleSendTransactionKit, disabled: isSending || isSigningKit || isSendingKit || isSignAndSending || isKitTransactionDemo, children: isSendingKit ? 'Sending...' : 'Send Transaction (Dual)' })] }), (0, jsx_runtime_1.jsxs)("div", { className: "button-section", children: [(0, jsx_runtime_1.jsx)("h5", { children: " New Dual Architecture Methods" }), (0, jsx_runtime_1.jsx)("button", { className: "send-button new-method-button", onClick: handleSignAndSendTransaction, disabled: isSending || isSigningKit || isSendingKit || isSignAndSending || isKitTransactionDemo, children: isSignAndSending ? 'Processing...' : 'Sign & Send (Combined)' }), (0, jsx_runtime_1.jsx)("button", { className: "send-button kit-pure-button", onClick: handleKitTransactionDemo, disabled: isSending || isSigningKit || isSendingKit || isSignAndSending || isKitTransactionDemo, children: isKitTransactionDemo ? 'Testing...' : 'Kit Architecture Demo' })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "architecture-info", children: [(0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("strong", { children: " Goal:" }), " Same methods handle both web3.js and kit inputs!"] }), (0, jsx_runtime_1.jsx)("p", { children: "Watch the log to see architecture detection in action." })] })] }) })] }));
};
exports.TransactionCard = TransactionCard;
